import React, {useEffect} from 'react';
import moment from "moment";
import {PieChart} from "react-minimal-pie-chart";
import './style.scss';

function getPieChartData(timeTillFinish, duration, color) {
    if (timeTillFinish === undefined || duration === undefined || timeTillFinish > duration) {
        duration = 1;
        timeTillFinish = 1;
    }

    const finishRatio = (duration - (timeTillFinish > 0 ? timeTillFinish : 0)) / (duration > 0 ? duration : 1);
    const finishRatioBy90 = Math.floor(finishRatio * 360);

    const data = [];

    const greens = new Array(Math.floor(finishRatioBy90 / 60)).fill(60).concat(finishRatioBy90 % 60).filter(a => a !== 0);
    const transparent = [].concat(new Array(Math.floor((360 - finishRatioBy90) / 60)).fill(60)).filter(a => a !== 0);

    greens.forEach(value => data.push({value: value, color: color}));
    transparent.forEach(value => data.push({value: value, color: 'transparent'}));

    return {data, percent: Math.ceil(finishRatio * 100)};
}

export function isNumeric(str) {
    if (typeof str != "string") return false // we only process strings!
    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

export default function RouteTimeCircle({
                                            status,
                                            totalDuration,
                                            durationTillFinish,
                                            color = '#43e327',
                                            backgroundColor = "#cdcdcd",
                                            children = null
                                        }) {
    const [innerPieChart, setInnerPieChart] = React.useState(null);
    const [pieChartTextFragment, setPieChartTextFragment] = React.useState(null);

    useEffect(() => {
            if (status !== "ASSIGNED" && status !== "SEARCHING_FOR_DRIVER" && durationTillFinish !== undefined && durationTillFinish !== null) {
                const {data} = getPieChartData(durationTillFinish, totalDuration, color);

                setInnerPieChart(
                    <div className="foreground-pie-chart">
                        <PieChart
                            lineWidth={12}
                            paddingAngle={15}
                            startAngle={277}
                            totalValue={360}
                            rounded
                            animate
                            data={data}
                        />
                    </div>
                );
            } else if (innerPieChart !== null)
                setInnerPieChart(null);

            let pieChartTextFragmentTmp;

            if (children) {
                pieChartTextFragmentTmp = children;
            } else if (status === "ASSIGNED") {
                pieChartTextFragmentTmp = (
                    <React.Fragment>
                        <div className="pie-chart-text-value-description">
                            ממתין
                        </div>
                        <div className="pie-chart-text-value-description">
                            לאיסוף
                        </div>
                    </React.Fragment>
                );
            } else if (status === "SEARCHING_FOR_DRIVER") {
                pieChartTextFragmentTmp = (
                    <React.Fragment>
                        <div className="pie-chart-text-value-description">
                            מחפש
                        </div>
                        <div className="pie-chart-text-value-description">
                            שליח
                        </div>
                    </React.Fragment>
                );
            } else if (durationTillFinish <= 0) {
                pieChartTextFragmentTmp = (
                    <React.Fragment>
                        <div className="pie-chart-text-value-description">
                            אמור
                        </div>
                        <div className="pie-chart-text-value-description">
                            לסיים
                        </div>
                    </React.Fragment>
                );
            } else {
                const chosenDurationToShow = durationTillFinish !== undefined && durationTillFinish !== null ?
                    durationTillFinish :
                    totalDuration;

                const routeDurationText = moment.duration(chosenDurationToShow, "seconds").humanize();
                const splittedDuration = routeDurationText.split(' ');

                pieChartTextFragmentTmp = (
                    <React.Fragment>
                        <div
                            className={isNumeric(splittedDuration[0]) ? "pie-chart-text-value" : "pie-chart-text-value-description"}>
                            {splittedDuration[0]}
                        </div>
                        <div className="pie-chart-text-value-description">
                            {splittedDuration[1]}
                        </div>
                    </React.Fragment>
                );
            }

            setPieChartTextFragment(pieChartTextFragmentTmp);
        },
        [status, totalDuration, durationTillFinish, children]);

    return (
        <div
            className="route-time-circle">
            <div className="pie-charts-container">
                <div className="background-pie-chart">
                    <PieChart
                        lineWidth={12}
                        paddingAngle={15}
                        startAngle={277}
                        rounded
                        animate
                        data={[...Array(6)].map(() => ({value: 1, color: backgroundColor}))}
                    />
                </div>
                {innerPieChart}
            </div>
            <div className="pie-chart-text-container">
                <div className="pie-chart-text">
                    {pieChartTextFragment}
                </div>
            </div>
        </div>
    )
}